import moment from 'moment';

export const parseDate = (value: unknown): string[] => {
  if (!value) return [];
  if (Array.isArray(value)) return value.filter((v) => !!v).map(String);
  if (typeof value === 'string') return value.split(',').map(String);
  return [];
};

export const unixConversion = (timestamp: string | number): number => {
  const string = String(timestamp);

  // unix in milliseconds
  if (string.length === 13) {
    return Number(timestamp);
  }

  // unix in seconds
  if (string.length === 10) {
    return Math.floor(Number(timestamp) * 1000);
  }

  // now milliseconds
  return moment().utc().valueOf();
};

export const unixProtectConversion = (timestamp: string | number): number | null => {
  const string = String(timestamp);

  // unix in milliseconds
  if (string.length === 13) {
    return Number(timestamp);
  }

  // unix in seconds
  if (string.length === 10) {
    return Math.floor(Number(timestamp) * 1000);
  }

  return null;
};
